import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class UsersUploadService {

constructor(private ws: PostmethodService) { }

  bulkUpload(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "reports/bulkImportUser");
  }

  bulkUploadDSE(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "reports/bulkImportDSEUser");
  }
  
  bulkUploadDD(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "reports/bulkImportDDUser");
  }

  uploadBucket(request: any) {
    return this.ws.wsPostFile(request, environment.baseUrl + "reports/presigned-url");
  }

  uploadFileByUrl(requestUrl: any, file:File) {
    return this.ws.wsPutByUrl(requestUrl,file);
  }
}
